module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-input"
  }, [_c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    staticClass: "input is-large",
    attrs: {
      "placeholder": this.placeholder || 'Search'
    },
    domProps: {
      "value": _vm.keyword
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.isOpen = false
      },
      "blur": function($event) {
        _vm.isOpen = false
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.moveDown($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.moveUp($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.select($event)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "options-list"
  }, _vm._l((_vm.fOptions), function(option, index) {
    return _c('li', {
      class: {
        'highlighted': index === _vm.highlightedPosition
      },
      on: {
        "mouseenter": function($event) {
          _vm.highlightedPosition = index
        },
        "mousedown": _vm.select
      }
    }, [_c('article', {
      staticClass: "media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": option.thumbnail
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "media-right"
    }, [_c('strong', [_vm._v(_vm._s(option.title))])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ea7daf8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Home/components/SearchBar.vue
// module id = 713
// module chunks = 1